"use client";
import { useEffect, useState } from 'react';

import Footer from "@/app/ui/footer";
import Header from "@/app/ui/header";
import HeaderNav from "@/app/ui/headernav";
import { useLanguage } from "@/app/utils/LanguageContext";

import { getTrainersEntries, getBusinessDate } from "@/app/utils/request/requestList";
import { getFOStageResult, getAssetPrefix, getCurrentTimeFormatted, adobeData, getSearchParams, updateMetaTag, MeetingState, mapRaceClassList} from "@/app/utils/Common";
import Remarks from "@/app/ui/Common/remarks";
import "./index.scss";
import NoInformation from "@/app/ui/Common/NoInformation";
import dayjs from 'dayjs';
import _ from 'lodash';
import { pageSet } from "@/app/utils/pageSet";

function ChangeDivWidth() {
  var trainersInfo = document.getElementById("trainersInfo");
  
  if (trainersInfo) {
      var trainersInfoWidth = trainersInfo.offsetWidth; // 获取宽度
      var content = document.querySelector("#contentContainer .content") as any;
      var contentWidth = content?.offsetWidth;

      if (content && trainersInfoWidth > contentWidth) {
        const trainerentriesDom = document.getElementById("trainerentries") as any; 
        const contentContainerDom = document.getElementById("contentContainer") as any; 
        trainerentriesDom.style.width = (trainersInfoWidth + 5) + 'px';
        content.style.width = (trainersInfoWidth + 5) + 'px';
        contentContainerDom.style.width = (trainersInfoWidth + 67) + 'px';
      }
  }
}

const TrainerEntrisTable = (props:any) => {
  const { state: lang } = useLanguage();
  const [data, setData ] = useState({} as any);
  const [meetings, setMeetings ] = useState([]);
  const [raceMeetings, setraceMeetings ] = useState([]);
  const [trainerStat, settrainerStat ] = useState([]);
  const [stage, setStage ] = useState(0);
  const [loading, setloading ] = useState(true);
  const [nextRacingDate, setnextRacingDate ] = useState("");
  const [dateTitle, setdateTitle ] = useState("");
  const { t, langCode } = lang;
  const assetPrefix = getAssetPrefix();
  const [bizdate, setbizdate] = useState("");
  const [AllRacesNoPool, setAllRacesNoPool] = useState(false);
  const [allAbandonInd, setallAbandonInd] = useState(false);
  const [curData, setcurData] = useState("");
  const [raceClassList, setraceClassList] = useState([] as any);
  //1: hasData, 2: noinfo
  const [hasData, setHasData] = useState(1);
  const { racedate } = typeof window !== 'undefined' && getSearchParams(new URLSearchParams(window?.location?.search));
  const regex = /^\d{4}\/\d{2}\/\d{2}$/;
  const isTNCUrl = () => window.location.pathname.toLowerCase().indexOf("tnc-entries") > 0;

  useEffect(() => {
    updateMetaTag(langCode, isTNCUrl() ? pageSet.tncentries : pageSet.trainersentries);
    adobeData(langCode, "pageview", {
      pageId: "racing/local",
    });
    // getBusinessDate().then((res:any) => {
    //   const resbizdate: string = res?.timeOffset?.ts?.substring(0, res?.timeOffset?.ts?.indexOf('+'));
    //   console.log(resbizdate,"resbizdate------------")
      // if (regex.test(racedate) && dayjs(racedate).isBefore(resbizdate)) {
      //   setloading(false);
      // } else {
        // setbizdate(resbizdate);
      // }
    // })

  }, [])
  useEffect(() => {
    getTrainersEntries("")
    .then((res: any) => {
      if(!res)
      {
        setHasData(2);
        setloading(false);
        return;
      } 
      console.log("getTrainersEntries", res)
      const resmeeting = res?.commonMeetings?.filter((x:any) => MeetingState("DECLARED").includes(x.status)) || [];
      let targetMeeting = {} as any;
      let resmeetingRace = [] as any;
      let respmPools = [] as any;
      const format_Date = 'DD/MM/YYYY';
      let tempDate = "";
      if (racedate && regex.test(racedate)) {
        targetMeeting = resmeeting?.find((i:any) => i?.date == racedate?.replaceAll("/", "-"));
        if (!targetMeeting) {
          setloading(false);
          return 
        } else {
          resmeetingRace = targetMeeting?.races || [];
          respmPools = targetMeeting?.pmPools || [];
          setnextRacingDate(dayjs(racedate, 'YYYY/MM/DD').format(format_Date));
        }
        tempDate = racedate?.replaceAll("/", "-");
      } else {
        resmeetingRace = resmeeting?.[0]?.races || [];
        respmPools = resmeeting?.[0]?.pmPools || [];
        setnextRacingDate(dayjs(resmeeting?.[0]?.date).format(format_Date));
        targetMeeting = resmeeting?.[0];
        tempDate =  resmeeting?.[0]?.date;
      }
      
      getFOStageResult(tempDate, "TNC").then((resStage:any) => {
        setStage(resStage);
        console.log('[resStage----]', resStage)
      });

      setMeetings(resmeeting);
      setraceMeetings(resmeetingRace);
      const restrainerStat = res?.trainerStat || [];
      const trainerList = [] as any;

      const notIncludesStatus = ["Standby", "Scratched"];
      resmeetingRace?.forEach((ele:any) => {
        ele?.runners?.forEach((ele2:any) => {
          if (!notIncludesStatus.includes(ele2?.status)) {
            const targetWinOdds = respmPools?.find((i:any) => i?.leg?.number == ele?.no)?.oddsNodes?.find((ii:any) => parseInt(ii?.combString) == ele2?.no)?.oddsValue || "";
          
            const targetTrainer = trainerList.find((i:any) => i?.trainerCode == ele2?.trainer?.code)
            let HName = "";
            if (!notIncludesStatus.includes(ele2?.status)) {
              HName = lang.langCode == "en-us" ? ele2?.horse?.name_en: ele2?.horse?.name_ch
            }

            const trainerPreference = ele2?.trainerPreference > 1? ele2?.trainerPreference : "";
            const trumpCard = ele2?.trumpCard ? "+": "";
            const priority = ele2?.priority ? "*": "";
            const displayHorseAndTag = [HName, trumpCard, priority, trainerPreference].filter((i:any) => i != "").join("&nbsp;")
            // new trainer
            if(!targetTrainer) {
              trainerList.push({
                trainerCode: ele2?.trainer?.code,
                trainerName: lang.langCode == "en-us" ? ele2?.trainer?.name_en: ele2?.trainer?.name_ch,
                trainerName_en: ele2?.trainer?.name_en,
                trainerHorseList: [{
                  horseName: HName,
                  horseID: ele2?.horse?.id,
                  horseCode: ele2?.horse?.code,
                  winOdds: targetWinOdds == "---" ? "" : parseFloat(targetWinOdds || ""),
                  // winOdds: ele2?.winOdds,
                  raceNo: ele?.no,
                  trainerPreference,
                  trumpCard,
                  priority,
                  displayHorseAndTag
                }],
              })
            } else {
              
              targetTrainer?.trainerHorseList?.push({
                horseName: HName,
                // winOdds: ele2?.winOdds,
                winOdds: targetWinOdds == "---" ? "" : parseFloat(targetWinOdds || ""),
                horseCode: ele2?.horse?.code,
                horseID: ele2?.horse?.id,
                raceNo: ele?.no,
                trainerPreference,
                trumpCard,
                priority,
                displayHorseAndTag
              })
            }
          }
          
        });
      });
      const initStatValue = {
        numFirst: 0,
        numSecond: 0,
        numThird: 0,
        numFourth: 0,
        numFifth: 0,
        numStarts: 0,
      }
      trainerList.forEach((ele:any) => {
        const tarEle = restrainerStat?.find((i:any) =>i?.code == ele?.trainerCode);
        if (tarEle) {
          ele.ssnStat = tarEle?.ssnStat?.find((i:any) => i?.ven == "ALL") || initStatValue;
        }else {
          ele.ssnStat = initStatValue;
        }
        if (tarEle) {
          ele.dhStat = tarEle?.dhStat?.find((x: any) => x?.ven?.toUpperCase() == "ALL") || initStatValue;
        } else {
          ele.dhStat = initStatValue;
        }
       
      });
      const tempSort = _.orderBy(trainerList,
        ["ssnStat.numFirst", "dhStat.numFirst",
        "ssnStat.numSecond", "dhStat.numSecond",
        "ssnStat.numThird", "dhStat.numThird",
        "ssnStat.numFourth", "dhStat.numFourth",
        "ssnStat.numFifth", "dhStat.numFifth",
        "ssnStat.numStarts",
        "trainerName_en"
      ],
      ["desc", "asc",
      "desc", "asc",
      "desc", "asc",
      "desc", "asc",
      "desc", "asc",
      "asc",
      "asc",
      ]) as any

      settrainerStat(tempSort);
      setAllRacesNoPool(MeetingState("DEFINED").includes(targetMeeting.status) && targetMeeting.totalNumberOfRace == targetMeeting.raNoPlCount);
      const _tempraceClassList = mapRaceClassList(targetMeeting);
      setraceClassList(_tempraceClassList);
      if (_tempraceClassList?.length) {
        setallAbandonInd(_tempraceClassList?.filter((x: any) => x.AbandonInd > 0)?.length == _tempraceClassList?.length);
      }
      
      if (racedate && regex.test(racedate)) {
        setcurData(racedate)
      } else {
        setcurData(resmeeting?.[0]?.date.replaceAll("-", "/"))
      }

      })
    .catch((e: any) => {
      console.log(e);
    }).finally(() => {
        setloading(false);
    });
  }, []);
  useEffect(() => {
    try {
      if (!loading) setTimeout(() => {
        ChangeDivWidth();
      });
    } catch (error) {
      
    }
  },[loading]);
  const renderRaceNoColumn = (No:any) => lang?.langCode == "en-us" ? `Race ${No}`: `第 ${No} 場`
  const renderStatus = (raceno:any) => {
    const abandonInd = raceClassList?.find((i:any) => i?.raceNo == raceno )?.AbandonInd;
    if (abandonInd > 1)  return t("Race_Abandoned").replace(" ", "<br/>")
    if (abandonInd > 0)  return t("Race_Voided").replace(" ", "<br/>")
    return ""
  }

  const handleTitleDate = (date: string) => lang.langCode == "en-us" ?
  `${new Date(date).getDate().toString().padStart(2, '0')} ${new Date(date).toLocaleString(lang.langCode, { month: "short" })}`
  : `${new Date(date).toLocaleString(lang.langCode, { month: "short" })}${new Date(date).getDate()}日 `;

  const handleRaceHeader = () => {
    return meetings?.map((item:any, idx:any) => {
        console.log('[------------item]', item)
        const curDate = handleTitleDate(item?.date);
        let btnClass = '';
        if (racedate && regex.test(racedate)) {
          if (racedate.replaceAll("/", "-") == item?.date){
            btnClass = "blueBtn1";
          }else {
            btnClass = "greyBtn";
          }
        } else {
          btnClass = idx == 0 ? "blueBtn1": "greyBtn"
        }
        return <a key={idx} className={btnClass} href={`/${lang.langCode}/local/info/${isTNCUrl() ? "tnc-entries":"trainers-entries"}?racedate=${item?.date.replaceAll("-", "/")}`} onClick={(event) => {
          if(btnClass =="blueBtn1") event.preventDefault();
        }}> {curDate} - {t(item?.venueCode)}</a>
      })
  }
  const handleTNCForTheDayStatus = () => {
    let msg = "";
    
    if (allAbandonInd && AllRacesNoPool) {
      msg = t("JKC_allAbandonInd_allRacesNoPool");
    }
    else if (allAbandonInd) {
      msg = t("JKC_allAbandonInd");
    }
    else if (AllRacesNoPool) {
      msg = t("JKC_allRacesNoPool");
    }
    else {
      msg = t("Willbereleased");
    }
    return msg;
  }
  if (loading) return null ;
  if (hasData == 2) return <NoInformation ssn_end={true} type="noinfo" />
  const imageSrc = `${assetPrefix}/images/title_${isTNCUrl()? "TNC_": ""}trainerEntries_${lang?.langCode == "en-us" ? "en" : "cn"}.gif`
  const directTitle = t("TNC_Entries_List");
 
  return meetings?.length ? <>
  <div className="commContent trainerEntries" id="trainerentries">
      <div style={{width: "920px"}}>
          <div className="commTitlePic">
              <img src={imageSrc} />
          </div>
          <div className="date_title f_tar">
              {handleRaceHeader()}
              {/* <a className="blueBtn1">{dateTitle}</a> */}
          </div>
      </div>

      <div id="trainers">
          <div 
          // className={"performance"} 
          id="trainers_info" style={{width: "920px", marginTop: 25}}>
              {
                stage > 2 ?   <div className={`f_tar titleHoverColorPurple`}>
                    <u><a href={`/${lang.langCode}/local/info/tnc-entries${curData? `?racedate=${curData}` : ""}`}>{directTitle}</a></u>
                </div>: null
              }
              
              {
                isTNCUrl() ? <div className={`f_tar f_fs13 flexEnd flexEndredired titleHoverColorPurple`}><u><a href={`/${lang.langCode}/local/info/trainers-entries${curData? `?racedate=${curData}` : ""}`}>{t("pagename_TrainerEntries")}</a></u></div>: null
              }
              <div className={`f_fs13 f_clear titleHoverColorPurple`}>
                  {t("Race_Meeting")}: {nextRacingDate}
                  {stage > 1 ? 
                      <p className="f_fr nav">{t("Last_Update_Time")} {getCurrentTimeFormatted()}<span>
                        <a onClick={()=> {window.location.href = window.location.href}} style={{cursor: "pointer"}}>[{t("Refresh")}]</a></span></p>
                      :null
                  }
              </div>
              {
                isTNCUrl() ? <div className={`f_fs13 flexEnd titleHoverColorPurple`} style={{color: "#039"}}>{handleTNCForTheDayStatus()}</div>: null
              }
              {
                raceMeetings.length ?
                  <div className="margin_top10">
                      <table id="trainersInfo" className="col_12 f_fs12" style={{width: "920px", lineHeight: "120%", minWidth: "100%"}}>
                          <thead>
                              <tr className="f_fs13">
                                  <th className="f_tac" style={{width: 70}}>{t("trainer")}</th>
                                  <th className="f_tac" style={{width: 115}}>{t("currentSeasonScore")}</th>
                                  {raceMeetings.map((race :any, indx: any)=> <th key={indx} className="f_tac bg_blue" >{renderRaceNoColumn(race?.no)}</th>)
                                  }
                              </tr>
                              <tr className="tdBgYellow2 f_fs13 f_tac">
                                  <td style={{whiteSpace: "nowrap", padding: '0 1px'}}>
                                      {t("Race_Class")}<br />
                                      {t("Dist.")}<br />
                                      {t("Track")}<br />
                                  </td>
                                  <td className="tdAlignVC" style={{verticalAlign: lang.langCode == 'en-us'? 'middle' : "top"}}>
                                      <div className="f_tac" style={{display: "table", width: lang.langCode == 'en-us'? "115px":"100%", tableLayout: "fixed"}}>
                                          <div className="tdAlignVC" style={{display: "table-cell"}}>{t("1st")}</div>
                                          <div className="tdAlignVC" style={{display: "table-cell"}}>{t("2nd")}</div>
                                          <div className="tdAlignVC" style={{display: "table-cell"}}>{t("3rd")}</div>
                                          <div className="tdAlignVC" style={{display: "table-cell"}} dangerouslySetInnerHTML={ {__html: t("total_Runs") } }></div>
                                      </div>
                                  </td>
                                  { raceMeetings?.map((race:any , indx:any)=> {
                                    console.log('[race?.status]', race?.status, race)

                                    let raceTrack = "";
                                    switch (race?.raceTrack?.code) {
                                      case "AWT":
                                        raceTrack = lang?.langCode == "en-us" ? race?.raceTrack?.code : "全天候";
                                        break;
                                      default:
                                        raceTrack = lang?.langCode == "en-us" ? race.raceTrack.description_en: race.raceTrack.description_ch
                                        break;
                                    }

                                    return <td key={indx} className="R1 tdBgYellow">
                                      {race.claCode}<br />
                                      {`${race.distance}${t("Meter")}`}<br />
                                      {raceTrack}<br />
                                      <span dangerouslySetInnerHTML={{ __html: renderStatus(race?.no)}}/>
                                  </td>
                                  })
                                      
                                  }
                              </tr>
                          </thead>
                          <tbody>
                              {
                                trainerStat.map((trainer:any, indx:any)  => {
                                  return (<tr key={indx}>
                                    <td className="f_tac alignL2" style={{padding: lang.langCode == 'en-us' ? "3px 2px" : "0 2px"}}>
                                        <a href={`/${lang.langCode}/local/information/trainerprofile?trainerid=${trainer?.trainerCode}`}>{trainer?.trainerName}</a>
                                    </td>
                                    <td className="alignL2" style={{padding: lang.langCode == 'en-us' ? "3px 2px" : "0 2px"}}>
                                        <div className="f_tac" style={{display: "table", width: lang.langCode == 'en-us'? "115px": "100%", tableLayout: "fixed"}}>
                                            <div className="tdAlignVC" style={{display: "table-cell"}}>{trainer?.ssnStat?.numFirst || 0}</div>
                                            <div className="tdAlignVC" style={{display: "table-cell"}}>{trainer?.ssnStat?.numSecond || 0}</div>
                                            <div className="tdAlignVC" style={{display: "table-cell"}}>{trainer?.ssnStat?.numThird || 0}</div>
                                            <div className="tdAlignVC" style={{display: "table-cell"}}>{trainer?.ssnStat?.numStarts || 0}</div>
                                        </div>
                                    </td>
                                    {
                                      raceMeetings.map((race:any, indx2: any) => {
                                        return  <td className="f_tac alignL2" key={indx2} style={{padding: lang.langCode == 'en-us' ? "3px 2px" : "0 2px", width: 72}}>
                                            {
                                              trainer?.trainerHorseList?.map((horse:any, iindx2: any) => {
                                                if (horse?.raceNo != race?.no) return null
                                                return <div style={{paddingBottom: lang.langCode == "en-us" ? 5 : 0}} key={iindx2}>
                                                {horse?.winOdds > 0 ? <><span className="color_red5">{horse?.winOdds}</span><br/></> : null}
                                                <a href={`/${lang.langCode}/local/information/horse?horseid=${horse?.horseID}`} style={{border:"0px"}}
                                                dangerouslySetInnerHTML={{__html: horse?.displayHorseAndTag}}>
                                                  {/* {horse?.horseName}{horse?.trumpCard}{horse?.priority}{horse?.trainerPreference} */}
                                                </a>
                                                </div>
                                              })
                                            }
                                      </td>
                                      })
                                    }
                                
                                </tr>)
                                })
                                  
                              }
                          </tbody>
                      </table>
                  </div>
                  :null
              }
          </div>
      </div>

      <Remarks path="TrainersEntries"/>

    </div>
</> : <NoInformation ssn_end={true} type="willbeavailable" PageName={t("pagename_TrainerEntries")} DirectPageName={t("pagename_RaceCard")} pageRemark="TrainersEntries"/>
}

const TrainerEntries: React.FC = () => {
  const { state: lang } = useLanguage();
 
  return (
    <>
      <div id='mainContainer'>
        <Header/>
        <HeaderNav/>
        <TrainerEntrisTable />
      </div>
      <Footer />
    </>
  );
};
export default TrainerEntries;